module.exports = __webpack_public_path__ + "static/img/envelope03vi.5017caa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/envelope03vi.png
// module id = 2Fjr
// module chunks = 1